import { createComponent } from '@carvana/merch-components';
import styled from 'styled-components';
import Sections from '~/constants/sections';

export const Wrapper = styled.main`
  --marketplace-color: var(
    ${props =>
      props.isMarketplace
        ? '--cvna-color-special-marketplace-purple'
        : '--vdp-teal'}
  );

  #${Sections.AncillaryProducts} {
    &.will-load,
    .section-is-loading {
      padding: 250px 0;
    }
  }

  #${Sections.KeyFeatures} {
    &.will-load,
    .section-is-loading {
      padding: 1000px 0;
    }
  }

  #${Sections.VehicleDetails} {
    &.will-load,
    .section-is-loading {
      padding: 1000px 0;
    }
  }

  #${Sections.OwnerReviews} {
    &.will-load,
    .section-is-loading {
      padding: 1000px 0;
    }
  }

  #${Sections.PriceDetails} {
    &.will-load,
    .section-is-loading {
      padding: 250px 0;
    }
  }

  #${Sections.Inspection150Point} {
    &.will-load,
    .section-is-loading {
      padding: 250px 0;
    }
  }

  #${Sections.BuyWithConfidence} {
    &.will-load,
    .section-is-loading {
      padding: 250px 0;
    }
  }
`;

export const HeroContainer = createComponent('div', {
  className: 'grid gap-y-20 bg-white p-20 m:gap-y-32 m:p-32'
});
